import { ApiRequestConfig } from 'api';
import { get } from 'features/api';
import { RequestProps, ResponseData, RelatedProducts } from '../types';

export function* fetchRelatedProducts(props: RequestProps, options: ApiRequestConfig) {
  const response = yield* get<ResponseData>('get-related-products', props, {
    ...options,
  });

  return response.data as RelatedProducts;
}
